import { TimezoneValues } from '../types';

const formatTimezone = () => {
    const timeZone = new Intl.DateTimeFormat('en-US', {
        timeZoneName: 'long',
    })
        .formatToParts(new Date())
        .find((part) => part.type === 'timeZoneName');

    return timeZone?.value || 'UTC';
};

export const MAP_COLLAPSED_PREFERENCE_KEY = 'EB.Venue.Event.Map.Collapsed';

export class TimezoneFactory {
    public static default(): TimezoneValues {
        return {
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            label: formatTimezone(),
        };
    }
}
